export const SESSION_EVENT = "cdoc:session";
export const AUTH_ROLES = ["SUPER_ADMIN", "TENANT_ADMIN", "TENANT_USER"];
let revision = 0;
export const sessionRevision = () => revision;
export const invalidateRequests = () => { revision += 1; };
export const validUser = (user) => !!user?.id && AUTH_ROLES.includes(user.role);
// Migrate away from persistent sign-in; never touch browser password-manager entries.
["cdoc_token", "cdoc_refresh", "cdoc_user", "cdoc_acting_tenant"].forEach((key) => localStorage.removeItem(key));

export function clearSession(broadcast = true) {
  invalidateRequests();
  ["cdoc_token", "cdoc_refresh", "cdoc_user", "cdoc_acting_tenant"].forEach((key) => localStorage.removeItem(key));
  ["cdoc_token", "cdoc_refresh", "cdoc_user", "cdoc_acting_tenant"].forEach((key) => sessionStorage.removeItem(key));
  if (broadcast) localStorage.setItem("cdoc_signout", `${Date.now()}:${Math.random()}`);
  window.dispatchEvent(new CustomEvent(SESSION_EVENT, { detail: false }));
}

export function saveSession(data, expectedRevision) {
  if (expectedRevision !== revision) throw new Error("Sessione cambiata durante la richiesta");
  if (!data.token || !validUser(data.user)) throw new Error("Sessione non valida");
  sessionStorage.setItem("cdoc_token", data.token);
  if (data.refresh_token) sessionStorage.setItem("cdoc_refresh", data.refresh_token);
  sessionStorage.setItem("cdoc_user", JSON.stringify(data.user));
  window.dispatchEvent(new CustomEvent(SESSION_EVENT, { detail: data.user }));
}

export function routeAllowed(user, roles, permission) {
  if (!validUser(user)) return false;
  if (roles && !roles.includes(user.role)) return false;
  return !permission || user.role !== "TENANT_USER" || user.permissions?.[permission] === true;
}
